import { render, staticRenderFns } from "./PendingEventsModal.vue?vue&type=template&id=23a55d23"
import script from "./PendingEventsModal.vue?vue&type=script&lang=js"
export * from "./PendingEventsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports